module.exports = __webpack_public_path__ + "assets/img/zqxglq.454f838a.png";